import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";

import { Theme } from "@holalink/react-ui-components";

import { MonitoringService } from "../services/MonitoringService";
import SimpleTable from "../../commons/components/SimpleTable";
import Loading from "../../commons/components/Loading";
import "../assets/Tables.css";

const Container = styled.div`
  margin-bottom: 25px;
`;
const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px;
`;

const CounterStyled = styled.span`
  font-weight: 700;
  font-family: Lato;
  font-style: italic;
  font-size: 18px;
  display: block;
  margin: 0 auto;
  @media screen and (max-width: 480px) {
    font-size: 16px;
  }
`;

const EmployeeCellContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  @media screen and (max-width: 480px) {
  }
`;

const ProfileIcon = styled.div`
  border-radius: 50%;
  background-color: ${Theme.colors.silver};
  height: 30px;
  width: 30px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  overflow: hidden;
`;

const TopUsersTable = ({ filter, currentCompany }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      field: "counter",
      headerName: "#",
      headerAlign: "center",
      width: "60",
      renderCell: (value) => <CounterStyled>{value}.</CounterStyled>,
    },
    {
      field: "names",
      headerName: "Nombre",
      width: "300",
      headerAlign: "center",
      renderCell: (value, row) => {
        return (
          <EmployeeCellContainer>
            <ProfileIcon>
              <img
                alt="profile"
                width="100%"
                height="100%"
                src={
                  (row && row.profileImage) ||
                  require("../../commons/assets/img/no-avatar-img.jpg")
                }
              />
            </ProfileIcon>
            {value}
          </EmployeeCellContainer>
        );
      },
    },
    {
      field: "job",
      headerName: "Cargo",
      width: "200",
      headerAlign: "center",
    },
    {
      field: "phone",
      headerName: "Teléfono",
      width: "200",
      headerAlign: "center",
    },
    {
      field: "views",
      headerName: "Vistas",
      width: "250",
      headerAlign: "center",
    },
  ];

  useEffect(() => {
    setLoading(true);
    if (currentCompany && currentCompany.id) {
      MonitoringService.getVisitsByEmployee(currentCompany.id, filter)
        .then((res) => {
          if (res.status === 200) {
            setData(res.data.visitsData);
          } else {
            console.log(res.data.message);
          }
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [filter, currentCompany]);

  return (
    <Container>
      {loading && (
        <LoadingContainer>
          <Loading />
        </LoadingContainer>
      )}
      {!loading && (
        <SimpleTable
          className="table-top-users"
          rows={data || []}
          columns={columns}
          noDataMessage="No hay eventos registrados"
          title="Top Visitas Colaboradores"
          variant="primary"
        ></SimpleTable>
      )}
    </Container>
  );
};

export default TopUsersTable;
